import gql from 'graphql-tag';

export const ORG_PERMISSIONS_QUERY = gql`
  query OrgPermissions($id: ID!) {
    organizationById(id: $id) {
      name
      logo
      permgroups {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_ALL_GROUPS_QUERY = gql`
query GetAllGroups {
  getAllGroups {
    edges {
      node {
        id
        name
        permissions {
          id
          name
          codename
        }
      }
    }
  }
}
`;

export const UPDATE_ORG_PERMISSIONS_MUTATION = gql`
  mutation UpdateOrganizationPermissions($id: ID!, $permgroups: [Int!]) {
    updateOrganization(id: $id, permgroups: $permgroups) {
      organization {
        id
        permgroups {
          edges {
            node {
              name
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_USER_GROUPS = gql`
  mutation updateUserGroups($userId: Int!, $groupIds: [Int!]!) {
    updateUserGroups(userId: $userId, groupIds: $groupIds) {
      ok
    }
  }
`;
